import React, { useEffect,useState,createRef } from 'react';
import { Button, Modal } from 'react-bootstrap';
import {useTranslation} from 'react-i18next';
import {toast} from 'react-toastify';
import {useFormik} from 'formik';
import * as Yup from 'yup';
import CustomSelect from '../../components/custom-select/CustomSelect';
import AlertDialog from '../../components/alert-dialog/AlertDialog';
import DatePicker, { registerLocale, setDefaultLocale } from "react-datepicker";
import moment from 'moment';
import PartnerModalWithDatatable from '../partner/PartnerModalWithDatatable';
import * as RestService from '../../services/eisRest';





  const PartnerDataModal = (props) => {

   

    const [t] = useTranslation();      
    const [isOpen, setIsOpen] = useState(false);
    
    const [selectedRecord, setSelectedRecord] = useState();
    const [entityId, setEntityId] = useState();
    const [partnerData, setPartnerData] = useState([]);  
    const [openAlertDialog, setOpenAlertDialog] = useState(false);    
    const dialogRef = createRef();
    const [showPartnerModalWithDatatable, setShowPartnerModalWithDatatable] = useState(false);
    const [loadedPartnerData, setLoadedPartnerData] = useState();

    const handleOpenPartnerList = () => {
      setShowPartnerModalWithDatatable(true);
    }

    const handleCallback = (show,id) => {         
      setShowPartnerModalWithDatatable(show);             
      getDataAboutPartnerData(id);
    };
    
  
    const hideModal = () => {
      setIsOpen(false);
      showChanged(false);
    };

    const showChanged = (newStatus) => {
      props.parentCallback(newStatus);
    }
    
    const deleteRecord = () => {
      setOpenAlertDialog(true);
    };

    useEffect(() => {
      formik.resetForm();
      setIsOpen(props.modal);
      showChanged(props.modal);

    }, [props.modal])

    const getDataAboutPartnerData = (id) => {
      RestService.callAnyApi('partner/getPartner?id='+id, null)
      .then((data) => {
        setLoadedPartnerData(data);        
        formik.setFieldValue("name",data.address.name);
      })
      .catch((error) => {
        console.log(error);
      });
    }


    useEffect(() => {      
      setSelectedRecord(props.selectedRecord);
      RestService.callAnyApi('article/getArticlePartnerData?id='+props.selectedRecord+"&articleId="+entityId, null)
      .then((data) => {
           getDataAboutPartnerData(data.partnerId);        
           setPartnerData(data);         
      })
      .catch((error) => {
        console.log(error);
      });

    }, [props.selectedRecord])

  
    useEffect(() => {      
      setEntityId(props.entityId);
    }, [props.entityId])

   

    const handleAlertDialogCallback = (clickedValue) => {
      setOpenAlertDialog(false);
      if(clickedValue==='OK'){
        RestService.callAnyApi('basic/deleteRecord?entity=articlePartnerData&id='+props.selectedRecord, null).then(
          (data) => {
            hideModal();
          })
          .catch((error) => {
            console.log(error);
          });
      }
      
    }
    

    
    const showError = (error,serverMessage) =>{
      if(serverMessage==null){
          toast.error(
            (error.response &&
                error.response.data &&
                error.response.data.message &&
                error.responseMessage) ||
                t('general.message.failed')
          );
        }else{
          toast.error(serverMessage);
        }
    }

    const save = (url,values) => {
         
  //    partnerData.entityId=props.entityId;
    //  partnerData.bankId=values.bankId;
    //  partnerData.currency=values.currency;
    //  partnerData.departmentId=values.departmentId;
     // partnerData.iban=values.iban;
      partnerData.partnerId = loadedPartnerData.id;
      partnerData.partnerCatalog = values.partnerCatalog;
      partnerData.description = values.description;     
     
      RestService.callAnyApi(url, partnerData)
          .then((data) => {                                                 
                      if(data.responseMessage==='OK'){
                          toast.success(t('general.message.saveSucceed'));                                              
                          hideModal();
                      }else{
                          showError(null,data.responseMessage);
                      }
                  
                 
          })
          .catch((error) => {               
            showError(error,null);
          });
    };

    const formik = useFormik({
      enableReinitialize: true,
      initialValues: {    

        partnerCatalog : partnerData.partnerCatalog,  
        description : partnerData.description
       // bankId: partnerData.bankId || "",
       // currency: partnerData.currency || "",
       // departmentId: partnerData.departmentId || "",
       // iban: partnerData.iban || "",
      },
      validationSchema: Yup.object({
      //   bankId: Yup.string()     
      //    .required(t('general.message.required')),
       //   currency: Yup.string()     
       //   .required(t('general.message.required')),
        //  iban: Yup.string()     
         // .required(t('general.message.required')),
      }),
      onSubmit: (values) => {           
          save('article/saveArticlePartnerData?articleId='+entityId,values);         
      }
    });

    return (
      <>    
        <div className="modal-container">
                  <Modal
                    show={isOpen}
                    onHide={hideModal}
                    container={this}
                    aria-labelledby="contained-modal-title"
                    centered
                    //size="lg"
                    ref={dialogRef}
                  >
                    <form onSubmit={formik.handleSubmit}>     
                    <Modal.Header closeButton>
                      <Modal.Title id="contained-modal-title">{t('article.label.partnerData')}</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                                
                         <div className="row"> 
                                <div className="col-12">
                                  <div className="form-group">
                                    <label>{t('general.label.name')}</label>
                                    <input type="text" class="form-control" readOnly onClick={handleOpenPartnerList} placeholder="" {...formik.getFieldProps('name')} />
                                  </div>
                                  {formik.touched.name && formik.errors.name ? (
                                    <div style={{ color: 'red' }}>{formik.errors.name}</div>
                                ) : null} 
                                </div>        
                          </div>

                          <div className="row">

                                <div className="col-6 col-sm-6 col-lg-6">
                                     <div className="form-group">
                                       <label>{t('articlePart.label.partnerCatalog')}</label>
                                       <input type="text" className="form-control"  {...formik.getFieldProps('partnerCatalog')} />                                   
                                     </div>
                                </div>

                          </div>
                           

                          <div className="row">
                               

                                <div className="col-12 col-sm-12 col-lg-12">
                                     <div className="form-group">
                                       <label>{t('general.label.description')}</label>
                                       <input type="text" className="form-control" {...formik.getFieldProps('description')} />                                   
                                     </div>
                                </div>
                          </div>
                           

                    </Modal.Body>
                    <Modal.Footer>                          
                          <Button style={selectedRecord ? {} : { display: 'none' }} className="btn-danger" onClick={deleteRecord}>{t('general.button.delete')}</Button>    
                          <Button style={entityId ? {} : { display: 'none' }} className="btn-primary" type="submit">{t('general.button.save')}</Button>    
                          <Button className="btn-default" onClick={hideModal}>{t('general.button.cancel')}</Button>
                    </Modal.Footer>
                    </form>  
                                        
                  </Modal>                                      
                </div>
               
                <AlertDialog
                open={openAlertDialog}
                message={t('general.message.areYouSure')}
                header={t('general.message.confirmDelete')}
                parentCallback={handleAlertDialogCallback}
                ></AlertDialog> 

          <PartnerModalWithDatatable         
            parentCallback={handleCallback}    
            modal={showPartnerModalWithDatatable}                                
          />
      </>
    );
  };

 export default PartnerDataModal;